import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import ModalFixed from "../../components/ModalFixed";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";

import Breadcumbs from "../../components/Breadcumbs";
import { NavLink } from "react-router-dom";

import ConectUs from "../../components/ConectUs";

import ImageGallery from "../../components/ImageGallery";
import { PosgradoPostulacionFixed } from "../../components/Pasos";
import Modal from "../../components/Modal";

import OfferPresencial from "../../components/view/OfferPresencial";
import PresencialPagos from "../../components/PresencialPagos";
import BlockRightImage from "../../components/BlockRightImage";
import BlockLeftImage from "../../components/BlockLeftImage";

function Presencial() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            {" "}
            <div className="relative">
              <BlockImageCabecera
                src={item.field_portada}
                title={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_texto_portada,
                      }}
                    />
                  </>
                }
              ></BlockImageCabecera>

              {/*   <ModalFixed
                color="#00bcd4"
                title="Conoce los pasos para inscribirte a la prueba 💙🐆"
                content={
                  <>
                    <iframe
                      width="100%"
                      height="400"
                      src="https://www.youtube.com/embed/u-v0tQFxWa0?si=_o-iZN8h_44JqCyy"
                      frameborder="0"
                      allowfullscreen
                    ></iframe>
                  </>
                }
              >
                {" "}
              </ModalFixed> */}
            </div>{" "}
            <Breadcumbs
              content={
                <>
                  <NavLink to="/presencial">Modalidad Presencial</NavLink>
                </>
              }
            ></Breadcumbs>
            <div
              className="layout6"
              dangerouslySetInnerHTML={{
                __html: item.field_bloque1,
              }}
            />
            <center>
              <div className="flex-start layout8 col2">
                <div className="green-etiqueta">
                  <h4>
                    {" "}
                    Carreras con <b>prueba diagnóstica:</b>
                  </h4>

                  <div className="flex items-start gap-3 bg-amber-50 border-l-4 border-amber-400 p-4 rounded-xl">
                    <span className="text-amber-500 text-xl">ℹ️</span>

                    <p className="text-slate-700 font-medium ">
                      Completa tu proceso: Inscripción → Prueba diagnóstica →
                      Matrícula. <br></br> Cupos limitados: disponibles hasta
                      completar el total por carrera{" "}
                    </p>
                  </div>
                  <p>
                    {" "}
                    <b> Inscripción y evaluación:</b> del 18 de febrero al 25 de
                    septiembre de 2026
                  </p>
                  <a
                    className="link-with-arrow"
                    href="https://www.utpl.edu.ec/carreras/sites/default/files/manual_presencial.pdf"
                  >
                    Manual de postulación
                  </a>
                </div>{" "}
                <div className="red-etiqueta">
                  <h4>
                    {" "}
                    Carreras con <b>prueba de admisión:</b>
                  </h4>
                  <p>
                    <b>Convocatoria </b> cerrada
                  </p>

                  <a className="button" href="/horarios-prueba-admision">
                    {" "}
                    Consulta el horario de tu prueba de admisión
                  </a>
                </div>
              </div>
            </center>
            <div className="margin">
              <OfferPresencial></OfferPresencial>
            </div>
            {/*   <div className="padding">
              <PresencialPagos></PresencialPagos>
            </div> */}
            <div className="margin">
              <div className="relative">
                <BlockLeftImage
                  src={item.field_imagen2}
                  content={
                    <>
                      {" "}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque2,
                        }}
                      />
                      <Modal
                        color="#6d46ce"
                        id="tematicas"
                        title="Consulta las temáticas de la prueba 📘"
                        content={
                          <>
                            <img src={item.field_imagen4} alt="utpl"></img>
                          </>
                        }
                      ></Modal>
                    </>
                  }
                ></BlockLeftImage>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/servicio-presencial.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
      <div className="padding2">
        <ConectUs
          lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes presenciales."
          facebook="https://www.facebook.com/utplpresencial/"
          instagram="https://www.instagram.com/utpl/"
          tiktok="https://www.tiktok.com/@utpl.ec"
        ></ConectUs>
      </div>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Presencial;
